export function getMinTimestampForCurrentOrdersReq(): number {
    /* We show current orders for the last 4 days,
     * but this value can be change anytime.
     */
    const msInDay: number = 86400000;
    const rangeToShow: number = msInDay * 4;
    const currentTimestamp: number = new Date().getTime();
    const minTimestamp: number = currentTimestamp - rangeToShow;
    return minTimestamp;
}